<template>
  <div class="select-group">
    <div class="sku-row">
      <div v-for="(sub, index) in choices" :key="index"
           class="sku-row__cell"
           @click="choice = sub.name">
        <button class="btn btn-block" :class="[choice === sub.name ? 'default-ghost' : 'plant']">
          {{sub.label}}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SKUSelector',
  model: {
    props: {
      prop: 'value',
      event: 'input'
    }
  },
  props: {
    choices: {
      type: [Array],
      required: true
    },
    value: {
      required: true
    }
  },
  data: () => ({
    choice: ''
  }),
  computed: {},
  watch: {
    choice (val) {
      this.$emit('input', val)
    },
    value (val) {
      this.choice = val
    }
  },
  created () {
    this.choice = this.value
  },
  methods: {}
}
</script>

<style lang="scss">
.sku-row {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 0.5rem;
  text-align: center;
  margin-bottom: 0.5rem;

  &__cell {
    flex: 1 1 0;
    min-width: 0;
    cursor: pointer;

    .btn {
      width: 100%;
    }
  }
}
</style>
